// ----------------------------------------------------------------------
export const Typography = () => {
    return {
        MuiTypography: {
            styleOverrides: {
                paragraph: { marginBottom: 16 },
                gutterBottom: { marginBottom: 8 }
            }
        }
    };
};
//# sourceMappingURL=Typography.js.map